import { render } from "./AlertForm.component.vue?vue&type=template&id=4058b559&scoped=true&ts=true"
import script from "./AlertForm.component.vue?vue&type=script&lang=ts"
export * from "./AlertForm.component.vue?vue&type=script&lang=ts"

import "./AlertForm.component.vue?vue&type=style&index=0&id=4058b559&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4058b559"]])

export default __exports__